import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MenuService } from '@services/shared/menu.service';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-bottom-nav',
	imports: [SharedModule, RouterLink, RouterLinkActive],
	templateUrl: './bottom-nav.component.html',
	styleUrl: './bottom-nav.component.scss',
})
export class BottomNavComponent {
	private readonly menuService = inject(MenuService);

	openProfile(): void {
		this.menuService.setProfileModalState(true);
	}
}
